import { css } from '@microsoft/fast-element';
export const foundationSnackbarStyles = css `
  @keyframes append-animate {
    from {
      transform: translateX(100%);
      opacity: 0%;
    }

    to {
      transform: translateX(0%);
      opacity: 100%;
    }
  }

  @keyframes delete-animate {
    from {
      transform: translateX(0%);
      opacity: 100%;
    }

    to {
      transform: translateX(100%);
      opacity: 0%;
    }
  }

  :host {
    --snackbar-min-width: 356px;
    --snackbar-min-height: 55px;
    --snackbar-max-width: 496px;
    --snackbar-max-height: 55px;
  }

  .snackbar {
    animation: append-animate 0.3s linear;
    max-width: var(--snackbar-max-width);
    min-width: var(--snackbar-min-width);
    max-height: var(--snackbar-max-height);
    background-color: var(--fill-color);
    border-radius: calc(var(--control-corner-radius) * 1px);
    border-width: thin;
    border-color: var(--neutral-fill-rest);
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 35%);
    box-sizing: border-box;
    display: flex;
    position: fixed;
    bottom: 5px;
    flex-direction: row;
    padding: 2px 16px;
  }

  .snackbar-delete {
    animation: delete-animate 0.3s linear;
    opacity: 0%;
  }

  .snackbar::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    height: calc(100% - 2px);
    width: 2px;
    border-radius: 2px;
  }

  .content {
    display: flex;
    align-items: center;
    flex: 2;
    font-size: 12px;
    overflow: hidden;
  }

  .action {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 10px;
    flex: 1;
    overflow: hidden;
  }
`;
